import React, { useState } from 'react';
import { Paragraph } from '@tmov/design-system';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { ButtonCorrecao } from './buttonCorrecao';
import ModalComponent from '../../../../../../components/Modal';
import api from '../../../../../../services/api';

export function ButtonCorrecaoTransSat({
  idConsultaSolicitacao,
  idStatusConsulta,
  carregarSolicitacaoAtual,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const erroIntegracao = idStatusConsulta === 9;

  const enviarCadastro = async () => {
    const url = erroIntegracao
      ? '/transsat/reenviar-cadastro'
      : '/transsat/enviar-correcao';

    const textoMensagem = erroIntegracao ? 'cadastro' : 'correção';

    setLoading(true);
    await api
      .put(`${url}?idConsultaSolicitacao=${idConsultaSolicitacao}`)
      .then(() => {
        message.success('Envio realizado com sucesso!');
        carregarSolicitacaoAtual();
      })
      .catch(error => {
        message.error(
          error?.response?.data?.detail ||
            `Falha ao enviar ${textoMensagem} para Trans Sat`
        );
      })
      .finally(() => {
        setLoading(false);
        setOpenModal(false);
      });
  };

  return (
    <>
      <ButtonCorrecao
        setOpenModal={setOpenModal}
        loading={loading}
        text={erroIntegracao ? 'Reenviar cadastro' : 'Enviar correção'}
      />
      <ModalComponent
        title="Deseja enviar a correção para a Trans Sat?"
        visible={openModal}
        onOkFunction={() => enviarCadastro()}
        onCancelFunction={() => setOpenModal(false)}
      >
        <Paragraph variant="p2" fontWeight="semibold">
          A edição do cadastro do motorista foi realizada e salva com sucesso?
        </Paragraph>
      </ModalComponent>
    </>
  );
}

ButtonCorrecaoTransSat.propTypes = {
  idConsultaSolicitacao: PropTypes.number.isRequired,
  idStatusConsulta: PropTypes.number.isRequired,
  carregarSolicitacaoAtual: PropTypes.func.isRequired,
};
